import styled from 'styled-components';
import { Link } from 'react-router-dom';

const RecentItem = styled.div`
  display: flex;
  flex-direction: row;
  color: ${(props) => props.theme.colors.primaryText};
  background: ${(props) => props.theme.colors.white};
  padding: 4px;
  align-items: center;
  margin-bottom: 8px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.colors.primaryText};
    background: ${(props) => props.theme.colors.subBackground};
  }

  @media (max-width: 768px) {
    padding: 4px;
    margin-bottom: 4px;
  }

  @media (max-width: 480px) {
    padding: 2px;
    margin-bottom: 2px;
  }
`;

const ItemImage = styled.img`
  width: 25%;
  margin-right: 1rem;

  @media (max-width: 768px) {
    width: 25%;
    margin-right: 0.5rem;
  }

  @media (max-width: 480px) {
    width: 20%;
    margin-right: 0.25rem;
  }
`;

const ItemName = styled.div`
  max-width: 60%;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 4px;
  color: ${(props) => props.theme.colors.primaryText};

  @media (max-width: 768px) {
    max-width: 70%;
    font-size: 12px;
    margin-bottom: 1px;
  }

  @media (max-width: 480px) {
    max-width: 75%;
    font-size: 10px;
    margin-bottom: 0px;
  }
`;

export default function RecentProductCard({ data, style }) {
  const { idStyle, webTitle, filepath1 } = data;

  return (
    <RecentItem
      style={style}
      key={idStyle}
      as={Link}
      to={`/product?id=${idStyle}`}
    >
      <ItemImage src={`${process.env.REACT_APP_FILE_UPLOAD_URL}${filepath1}`} />
      <ItemName>
        <div dangerouslySetInnerHTML={{ __html: webTitle }} />
      </ItemName>
    </RecentItem>
  );
}
